import React, { useContext, useEffect, useState } from 'react';
import SideLeft from '../layout/SideLeft';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import AppContext from '../Context/AppContext';
import axios from 'axios';
import Card from '../layout/Card';
import ConversationsOnglets from '../components/ConversationsOnglets';
import ConversationTalk from '../components/ConversationTalk';
//import { useSocket } from '../Context/SocketContext';

const Messenger = () => {
    const nameLocal = "conv-storage";
    //const { setMessageReceived } = useSocket()
    const { mapUrl, setCurrentPage } = useContext(AppContext)
    const conversationStorage = localStorage.getItem(nameLocal) ? JSON.parse(localStorage.getItem(nameLocal)) : [];
    const [conversationTalk, setConversationTalk] = useState(null);
    const [conversations, setConversations] = useState(null);
    const [ongletConv, setOngletConv] = useState([]);

    useEffect(() => {
        setCurrentPage('messenger')
    }, [])
    const init = async () => {
        //setMessageReceived(false)
        const response = await axios.get(mapUrl.get_conversations);
        if (response.data) {
            setConversations(response.data);
            if (conversationStorage?.length > 0) {
                const matchSaveStorage = response.data.filter(e => conversationStorage.includes(e.tokenuser));
                setOngletConv(matchSaveStorage)
            }
            if (conversationTalk) {
                /** match */
                const match = response.data.find(e => e.tokenuser == conversationTalk.tokenuser);
                setConversationTalk(match);
            }
        }
    }
    const closeOnglet = (tokenuser) => {
        if (conversationTalk && conversationTalk.tokenuser == tokenuser) {
            if (ongletConv?.length > 1) {
                setConversationTalk(ongletConv[1])
            } else {
                setConversationTalk(null)
            }
        }
        setOngletConv(prev => prev.filter(conv => conv.tokenuser !== tokenuser))
    }
    const isAnswer = (conv) => {
        if (!conv.lastDateMessageAdmin) {
            return "🟢";
        }
        const lastDateMessage = new Date(conv.lastDateMessageAdmin);
        const lastDateMessageAdmin = new Date(conv.lastDateMessageAdmin)

        const adminHasReplied = lastDateMessageAdmin >= lastDateMessage;

        if (!adminHasReplied) {
            return "🟢";
        } else {
            return "⚪";
        }
    }
    const addConv = (item) => {
        setConversationTalk(item);
        setOngletConv(prev => {
            const exists = prev.some(conv => conv.tokenuser === item.tokenuser);
            return exists ? prev : [item, ...prev]
        });
    };
    const isOnOnglet = (conv) => {
        if (ongletConv?.length == 0) {
            return ''
        }
        return ongletConv.find(e => e.tokenuser == conv.tokenuser) ? "is-active" : ""
    }
    useEffect(() => {
        init()
    }, [])

    useEffect(() => {
        if (ongletConv?.length > 0) {
            localStorage.setItem(nameLocal, JSON.stringify(ongletConv.map(e => e.tokenuser)))
        }
    }, [ongletConv])
    return (
        <MainLayout>
            <CenterLayout>
                <ConversationsOnglets closeConversation={(tokenuser) => closeOnglet(tokenuser)} ongletConv={ongletConv} conversationTalk={conversationTalk} updateConvertionTalk={(v) => setConversationTalk(v)} />
                <ConversationTalk init={init} conversationTalk={conversationTalk} closeConv={(v) => closeOnglet(v)} />
            </CenterLayout>
            <SideLeft>
                {conversations?.length > 0 && conversations.map((conv, conv_i) => (
                    <div key={conv_i + "_conv"} className='mb1'>
                        <Card addClass={isOnOnglet(conv)}>
                            <button onClick={() => addConv(conv)} className='df aic jcsb w100'>
                                <div className='df aic'>
                                    <span className='mr1'>{isAnswer(conv)}</span>
                                    <p className='cw fr'>{conv.tokenuser}</p>
                                </div>
                                <p className='bcw cb fr df aic jcc' style={{ padding: "3px", borderRadius: "10px", height: "18px", width: "18px" }}>{conv.messages.length}</p>
                            </button>
                        </Card>
                    </div>
                ))}
            </SideLeft>
        </MainLayout>

    );
};

export default Messenger;